module.exports = __webpack_public_path__ + "static/media/upload.3dab2341.svg";